import { useCallback } from 'react';

import { equals } from 'ramda';
import { useEditorLoading, useSlateSelector } from 'src/layout-engine/hooks';

import { scanCrossReferenceTargets } from './cross-reference-targets';

/**
 * Collect the cross-reference targets matching `referenceType` from the open
 * document.
 */
export function useCrossReferenceTargets(referenceType: string, open: boolean) {
  const editorLoading = useEditorLoading();

  const targets = useSlateSelector(
    useCallback(
      editor => {
        if (!open || !referenceType || editorLoading) return [];
        return scanCrossReferenceTargets(editor, referenceType);
      },
      [editorLoading, open, referenceType]
    ),
    equals
  );

  return { targets };
}
